import React from "react"
import { MyControlHelpers } from "@macashipo/mlib"
const MCInputCurrency = React.lazy(() => import("./Types/input_currency"))
const MCInputPercentage = React.lazy(() => import("./Types/input_percentage"))
const MCInputText = React.lazy(() => import("./Types/input_text"))
const MCInputNumber = React.lazy(() => import("./Types/input_number"))
const MCGroupControls = React.lazy(() => import("./Types/group_controls"))
const MCInputDate = React.lazy(() => import("./Types/input_date"))
const MCSelect2UpdateMoreFields = React.lazy(
  () => import("./Types/select2_update_more_fields")
)
/**v1 page module*/
const v1_mfc_select2 = React.lazy(
  () => import("src/core/modules/v1page/MyControl/Types/select2")
)
const MCInputCheckbox = React.lazy(() => import("./Types/checkbox"))
const MCInputCheckboxCustom = React.lazy(
  () => import("./Types/checkbox_custom")
)

const List = {
  input_currency: MCInputCurrency,
  input_percentage: MCInputPercentage,
  input_text: MCInputText,
  input_number: MCInputNumber,
  group_controls: MCGroupControls,
  input_date: MCInputDate,
  select2_update_more_fields: MCSelect2UpdateMoreFields,
  v1_mfc_select2: v1_mfc_select2,
  input_checkbox: MCInputCheckbox,
  input_checkbox_custom: MCInputCheckboxCustom,
}
const MyControlSMSFOne = {
  init() {
    MyControlHelpers.addTypesFromListLazy(List)
  },
}

export default MyControlSMSFOne
